import { ImageValidationError, uploadImage } from './imageService';
import { getChatPhotoValidationError } from '../model/chatPhotoValidation';

/** Загружает фотографию для переписки */
export const uploadChatPhoto = async (file: File): Promise<string> => {
    const error = getChatPhotoValidationError(file.type, file.size);

    if (error) throw new ImageValidationError(error);

    return uploadImage(file);
};
